import { Box, HStack } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { OutgoingInvoiceTypeEnum } from "@src/__generated__/urql-graphql";
import { observer } from "mobx-react-lite";
import { useInvoiceDetailStore } from "../../../store";
import { CardTitle } from "../../common";
import { Details } from "./Details";
import { DownloadInvoiceButton } from "./DownloadInvoiceButton";
import { PaymentReceipt } from "./PaymentReceipt";
import { ProformaInvoice } from "./ProformaInvoice";
import { PurchaseOrder } from "./PurchaseOrder";
import { ViewInvoiceButton } from "./ViewInvoiceButton";

export const InvoiceDetails = observer(function InvoiceDetails() {
  const store = useInvoiceDetailStore();

  return (
    <Box pl="4">
      <CardTitle>
        {store.invoice?.type === OutgoingInvoiceTypeEnum.CreditNote
          ? t`Credit note details`
          : t`Invoice details`}
      </CardTitle>
      {(store.invoice?.isInvoice && <PurchaseOrder />) ||
        (store.invoice?.isProformaPayment && <ProformaInvoice />) ||
        (store.isProforma && <PaymentReceipt />)}
      <Details />

      <HStack spacing="2">
        <ViewInvoiceButton url={store.invoice?.invoicePdf?.preview}>
          {store.invoice?.type === OutgoingInvoiceTypeEnum.CreditNote
            ? t`View credit note`
            : t`View invoice`}
        </ViewInvoiceButton>
        <DownloadInvoiceButton url={store.invoice?.invoicePdf?.download}>
          {store.invoice?.type === OutgoingInvoiceTypeEnum.CreditNote
            ? t`Download credit note`
            : t`Download invoice`}
        </DownloadInvoiceButton>
      </HStack>
    </Box>
  );
});
